export const RECRUITMENT_TYPE_CAREFULLY = 1;
export const RECRUITMENT_TYPE_ASAP = 2;
